/* eslint-disable curly */
import React, { Component } from "react";
import {
  StyleSheet,
  View,
  Text,
  Dimensions,
  TextInput,
  TouchableOpacity,
  ImageBackground,
  KeyboardAvoidingView,
  Platform,
} from "react-native";
import Icon from "react-native-vector-icons/FontAwesome";
import { LinearGradient } from "expo-linear-gradient";

import styles from "./styles";
import { validarDataNascimento } from "../../services/aluno-service";
import ButtonConfirm from "../../components/ButtonConfirm";

class AdicionarRedeSocial extends Component {
  constructor(props) {
    super();
    this.state = {};

    props.navigation.navigationOptions = {
      gestureEnabled: false,
      headerShown: false,
    };
  }

  componentDidMount = () => {};

  handlerButtons = (target) => {
    let aluno = this.props.navigation.getParam("aluno");

    // if (target === "Facebook")
    //   return this.props.navigation.navigate("VincularFacebook", {
    //     aluno,
    //     target,
    //     cameFromHome: true,
    //   });

    this.props.navigation.navigate("InformarRedeSocial", {
      aluno,
      target,
      cameFromHome: true,
    });
  };

  render() {
    return (
      <KeyboardAvoidingView
        style={styles.container}
        behavior={this.isIos ? "padding" : "null"}
        enabled
      >
        <ImageBackground
          source={require("../../../resources/imgs/bg.jpg")}
          style={styles.container}
          imageStyle={styles.imageContainer}
        >
          <View style={styles.containerForm}>
            <Text style={styles.textHeader1}>Vamos manter contato sempre?</Text>
            <Text style={styles.textHeader2}>
              Adicione ao menos uma rede social
            </Text>
            <TouchableOpacity
              style={[
                styles.buttonEntry,
                {
                  borderColor: "#3B5998",
                  backgroundColor: "#3B5998",
                  marginTop: 60,
                },
              ]}
              onPress={() => {
                this.handlerButtons("Facebook");
              }}
            >
              <Icon
                name="facebook-square"
                size={30}
                style={{ marginRight: 10 }}
                color="#fff"
              />
              <Text style={[styles.textButton]}>Facebook</Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={{ width: "50%" }}
              onPress={() => {
                this.handlerButtons("Instagram");
              }}
            >
              <LinearGradient
                start={[0, 1]}
                end={[1, 0]}
                colors={["#f09433", "#e6683c", "#dc2743", "#cc2366", "#bc1888"]}
                style={[styles.buttonEntry, { borderWidth: 0, width: "100%" }]}
              >
                <Icon
                  name="instagram"
                  size={30}
                  style={{ marginRight: 10 }}
                  color="#fff"
                />
                <Text style={[styles.textButton]}>Instagram</Text>
              </LinearGradient>
            </TouchableOpacity>
            <TouchableOpacity
              style={[
                styles.buttonEntry,
                { borderColor: "#0e76a8", backgroundColor: "#0e76a8" },
              ]}
              onPress={() => {
                this.handlerButtons("Linkedin");
              }}
            >
              <Icon
                name="linkedin-square"
                size={30}
                style={{ marginRight: 10 }}
                color="#fff"
              />
              <Text style={[styles.textButton]}>Linkedin</Text>
            </TouchableOpacity>
            <Text
              style={[
                styles.textHeader2,
                { fontSize: 16, marginTop: 52, marginHorizontal: 12 },
              ]}
            >
              É necessário vincular uma rede social para usar as funcionalidades
              do app.
            </Text>
          </View>
        </ImageBackground>
      </KeyboardAvoidingView>
    );
  }
}

export default AdicionarRedeSocial;
